import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { recipe } from "@vanilla-extract/recipes";

const SIZE_MULTIPLIER = 1;

export const markerStyle = recipe({
  base: {
    width: rem(40 * SIZE_MULTIPLIER),
    height: rem(52 * SIZE_MULTIPLIER),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    position: "absolute",
    bottom: 0,
    transform: "translateX(-50%) !important",

    // Create the pin shape using before pseudo-element
    "::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: rem(40 * SIZE_MULTIPLIER),
      height: rem(40 * SIZE_MULTIPLIER),
      background: theme.colors.primary,
      borderRadius: "50% 50% 50% 0",
      transform: "rotate(-45deg)",
      zIndex: 1,
    },

    // Icon container
    "::after": {
      content: '""',
      position: "absolute",
      top: rem(8 * SIZE_MULTIPLIER),
      width: rem(24 * SIZE_MULTIPLIER),
      height: rem(24 * SIZE_MULTIPLIER),
      zIndex: 1,
    },

    selectors: {
      "&:hover::before": {
        // transform: "rotate(-45deg) scale(1.1)",
      },
    },
  },
  variants: {
    hoverable: {
      true: {
        pointerEvents: "auto",
        cursor: "pointer",
      },
    },
  },
});

export const markerShadowStyle = style({
  width: rem(40 * SIZE_MULTIPLIER),
  height: rem(40 * SIZE_MULTIPLIER),
  backgroundImage:
    "radial-gradient(circle, rgba(0, 0, 0, .25) 0%,  transparent 70%)",
  borderRadius: "50%",
  position: "absolute",
  left: 0,
  bottom: rem(-10 * SIZE_MULTIPLIER),
  zIndex: 0,
});
